<template>
    <div>
        <List :data="data" />
    </div>
</template>

<script>
// Components.
import List from './List'

export default {
    components: {List},
    props: {
        data: {type: Object, required: true},
    },
}
</script>